import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CartState} from "./cart.state";
import { CartItem } from "../../app/feutures/cart/interface/cart";
export const selectCartFeature = createFeatureSelector<CartState>('cart');


export const selectCartProducts = createSelector(
    selectCartFeature,
    (state): CartItem[] => state.cart?.cartItems ?? []
);


export const selectCartLoading =createSelector(
    selectCartFeature,
    (state) => state.loading
)   


export const selectNumOfCartItems = createSelector(
    selectCartFeature,
    state => state.numOfCartItems
) 

export const clearCartSuccess = createSelector(
    selectCartFeature,
    state => state.numOfCartItems=0
)

export const selectDiscount = createSelector(
    selectCartFeature,
    state => state.discount
)   

export const selectTotalPriceAfterDiscount = createSelector(
    selectCartFeature,
    (state) => {        
        if (!state.cart) return 0;

        const discountAmount = (state.cart.totalPrice * state.discount) / 100;
        return state.cart.totalPrice - discountAmount;
    }
);

export const selectSubtotal = createSelector(
  selectCartFeature,
  state => state.cart?.totalPrice ?? 0
);

export const selectDiscountPercentage = createSelector(
  selectCartFeature,
  state => state.discount
);

export const selectDiscountAmount = createSelector(
  selectSubtotal,
  selectDiscountPercentage,
  (subtotal, discount) => (subtotal * discount) / 100
);

export const selectTotalAfterDiscount = createSelector(
  selectSubtotal,
  selectDiscountAmount,
  (subtotal, discountAmount) => subtotal - discountAmount
);